const eventLocationTypes = {
  HELPTAP_LIVESTREAM: 'HELPTAP_LIVESTREAM',
  OTHERS: 'OTHERS'
};

export default eventLocationTypes;